import { createI18n } from 'vue-i18n';

const languages = [];

// LANGUAGES

import sqAL from './locales/sq-al.json';
import 'moment/dist/locale/sq';
languages.push({code: 'sq', numberFormat: 'sq-AL', name: 'Albanian', messages: sqAL, flag: '🇦🇱'});

import enUS from './locales/en-us.json';
languages.push({code: 'en', numberFormat: 'en-US', name: 'English', messages: enUS, flag: '🇬🇧'});

import frFR from './locales/fr-fr.json';
import 'moment/dist/locale/fr';
languages.push({code: 'fr', numberFormat: 'fr-FR', name: 'French', messages: frFR, flag: '🇫🇷'});

import deDE from './locales/de-de.json';
import 'moment/dist/locale/de';
languages.push({code: 'de', numberFormat: 'de-DE', name: 'German', messages: deDE, flag: '🇩🇪'});

import itIT from './locales/it-it.json';
import 'moment/dist/locale/it';
languages.push({code: 'it', numberFormat: 'it-IT', name: 'Italian', messages: itIT, flag: '🇮🇹'});

import plPL from './locales/pl-pl.json';
import 'moment/dist/locale/pl';
languages.push({code: 'pl', numberFormat: 'pl-PL', name: 'Polish', messages: plPL, flag: '🇵🇱'});

import roRO from './locales/ro-ro.json';
import 'moment/dist/locale/ro';
languages.push({code: 'ro', numberFormat: 'ro-RO', name: 'Romanian', messages: roRO, flag: '🇷🇴'});

import ruRU from './locales/ru-ru.json';
import 'moment/dist/locale/ru';
languages.push({code: 'ru', numberFormat: 'ru-RU', name: 'Russian', messages: ruRU, flag: '🇷🇺'});

import esES from './locales/es-es.json';
import 'moment/dist/locale/es';
languages.push({code: 'es', numberFormat: 'es-ES', name: 'Spanish', messages: esES, flag: '🇪🇸'});

import ukUA from './locales/uk-ua.json';
import 'moment/dist/locale/uk';
languages.push({code: 'uk', numberFormat: 'uk-UA', name: 'Ukrainian', messages: ukUA, flag: '🇺🇦'});

import trTR from './locales/tr-tr.json';
import 'moment/dist/locale/tr';
languages.push({code: 'tr', numberFormat: 'tr-TR', name: 'Turkish', messages: trTR, flag: '🇹🇷'});



// END LANGUAGES

import branding from '@/branding';

const messages: any = {};
for (const language of languages) {
  messages[language.code] = {message: language.messages};
}

function normalizeLocale(code: string | undefined | null): string | undefined {
  if (!code) return undefined;
  // navigator.language returns BCP-47 tags like "tr-TR"; our locales are short codes ("tr", "de").
  const short = code.split('-')[0].toLowerCase();
  return languages.some(l => l.code === short) ? short : undefined;
}

function getLocale() {
  let locale = normalizeLocale(localStorage.language);
  if (branding.isMobile && !locale) locale = normalizeLocale(navigator.language);
  if (!locale) locale = 'de';
  console.log('locale', locale);
  return locale;
}

function getLanguage(code: string) {
  return languages.find(language => language.code === code);
}

export const i18n = createI18n({
  locale: getLocale(),
  fallbackLocale: 'de',
  messages,
});

console.log(i18n);

export { getLocale, getLanguage, languages };